// can be used anywhere as a fallback in case the backend fails to return a
// proper error message
export const AI_GEN_CONTENT_FALLBACK_ERR = `Sorry!<br>Lavender's wizard potion needs stirring. Please try again.`;
